/**
 * @desc ToB客户信息-添加（包含驳回后修改重新提交 modifyFlag 1：重新发起；0：新增）
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  modifyFlag: number,
  body: defs.basics.BusinessCustomerListResponseDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/${modifyFlag}/add`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
